import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ReunionStoreState {
  activeReunionId: string | null;
  setActiveReunionId: (id: string | null) => void;
}

export const useReunionStore = create<ReunionStoreState>()(
  persist(
    (set) => ({
      activeReunionId: null,
      setActiveReunionId: (id) => set({ activeReunionId: id }),
    }),
    {
      name: 'reunion-selection',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
